import React from 'react';
import {IconProps} from "../../types/types";

const UnLoginIcon: React.FC<IconProps> = ({ size=32, color = 'white',...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 32 32" fill="none" {...props}>
        <path
            d="M24 14L26 12M24 14L22 12M24 14L22 16M24 14L26 16M18 12C18 14.2091 16.2091 16 14 16C11.7909 16 10 14.2091 10 12C10 9.79086 11.7909 8 14 8C16.2091 8 18 9.79086 18 12ZM10 19H18C20.2091 19 22 20.7909 22 23C22 23.5523 21.5523 24 21 24H7C6.44772 24 6 23.5523 6 23C6 20.7909 7.79086 19 10 19Z"
            stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

export default UnLoginIcon;